import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router';
import { toast } from 'react-toastify';

import apiUtil from 'src/api/userManagement';
import CustomToast from 'src/components/CustomToast';
import Loader from 'src/components/Loader';
import { AppContext } from 'src/containers/Core/AppContext';
import { addUserToBusinessSuccess } from 'src/containers/Core/Messages';
import { HOME, SIGN_UP } from 'src/containers/Core/Paths';
import { isAuthenticated, logout } from 'src/utils/common';

type InviteProps = {} & RouteComponentProps<{ uuid: string; token: string }>;

const Invite: React.FunctionComponent<InviteProps> = ({ match, history }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const [{ resolve, reject }, setPromise] = useState({ resolve: null, reject: null });
  const { store } = useContext(AppContext);

  useEffect(() => {
    onConfirm();
  }, []);

  const onConfirm = async () => {
    if (match.params.token) {
      setLoading(true);
      try {
        const decodedUserDetails = await apiUtil.verifyInvite(match.params.token);
        const {
          business: { name },
          email,
          isMember,
        } = decodedUserDetails;
        const value = await checkMySession(email);

        if (isMember) {
          if (value) {
            await apiUtil.acceptInvite(match.params.token);
            toast(<CustomToast type="success" description={addUserToBusinessSuccess(name)} />, {
              className: 'success',
            });
            history.replace(HOME);
          } else {
            history.replace(SIGN_UP, { email, token: match.params.token });
          }
        } else {
          history.replace(SIGN_UP, { token: match.params.token, email, name });
        }
      } catch (e) {
        close();
        history.replace(HOME);
      } finally {
        setLoading(false);
      }
    } else {
      history.replace(HOME);
    }
  };

  const checkMySession = async (decodedEmail: string) => {
    return new Promise((res, rej) => {
      setPromise({ reject: rej, resolve: res });

      if (isAuthenticated()) {
        if (store.user && store.user.email === decodedEmail) {
          res(true);
        } else {
          openConfirm();
        }
      } else {
        res(false);
      }
    });
  };

  const openConfirm = () => {
    setShowConfirmation(true);
  };

  const onHide = () => {
    reject(false);
    setShowConfirmation(false);
  };

  return (
    <>
      <Modal show={showConfirmation} onHide={onHide} centered>
        <Modal.Header className="font-size-16 font-weight-bold">
          There is an active session, By clicking yes your session will expire. Do you wish to continue?
        </Modal.Header>
        <Modal.Body>
          <Button
            onClick={() => {
              logout();
              resolve(false);
            }}
          >
            Yes
          </Button>
          <Button variant="light" className="mx-2" onClick={onHide}>
            No
          </Button>
        </Modal.Body>
      </Modal>
      {loading ? <Loader /> : null}
    </>
  );
};

export default Invite;
